import React, { useEffect, useState } from 'react';
import { Menu, X, Flame } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Manifesto',
    href: '#manifesto'
  }, {
    name: 'The Void',
    href: '#problems'
  }, {
    name: 'Offerings',
    href: '#features'
  }, {
    name: 'Covenant',
    href: '#pricing'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-obsidian/95 backdrop-blur-md border-b border-white/5 py-4' : 'bg-transparent py-6'}`} data-id="element-90">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <div className="flex justify-between items-center" data-id="element-92">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2 group" data-id="element-93">
            <motion.div animate={{
            opacity: [0.7, 1, 0.7]
          }} transition={{
            duration: 3,
            repeat: Infinity
          }} className="text-amber-glow" data-id="element-94">
              <Flame className="w-6 h-6" data-id="element-95" />
            </motion.div>
            <span className="font-heading text-2xl font-bold text-parchment tracking-widest group-hover:text-amber-glow transition-colors duration-300" data-id="element-96">
              Ravenhold
            </span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-97">
            {navLinks.map(link => <a key={link.name} href={link.href} className="font-heading text-sm text-bone/80 hover:text-amber-glow transition-colors duration-300 tracking-wider relative group" data-id="element-98">
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-amber-glow/50 transition-all duration-300 group-hover:w-full" data-id="element-99" />
              </a>)}
            <button className="px-5 py-2 font-heading text-sm text-obsidian bg-amber-glow hover:bg-amber-dim transition-colors duration-300 font-semibold tracking-wide" data-id="element-100">
              Enter
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-bone hover:text-amber-glow transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-101">
            {isMobileMenuOpen ? <X data-id="element-102" /> : <Menu data-id="element-103" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-104">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-charcoal border-b border-white/5 overflow-hidden" data-id="element-105">
            <div className="px-4 py-6 space-y-4 flex flex-col items-center" data-id="element-106">
              {navLinks.map(link => <a key={link.name} href={link.href} className="font-heading text-lg text-bone hover:text-amber-glow transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-107">
                  {link.name}
                </a>)}
              <button className="mt-4 px-8 py-3 font-heading text-obsidian bg-amber-glow hover:bg-amber-dim transition-colors w-full max-w-xs" data-id="element-108">
                Enter the Sanctum
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}